import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box } from '@mui/material';
// import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
export interface IProps {
    user: {
      email: string;
    };
  }
export interface IState {
    curation_stats: any;
    show: boolean;
    selectedBarcode: any;
    selectedProfiler: any;
    selectedRows: any[];
    toggleCleared: boolean;

    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: number;
}

class ReportsHeader extends React.Component<RouteComponentProps & WithTranslation& IProps, IState> {
    constructor(props: RouteComponentProps & WithTranslation& IProps) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        let activeTab = 0;
        if(current_path[2] == 'community-report'){
            activeTab = 0;
        } else if(current_path[2] == 'city-report'){
            activeTab = 1;
        } else if(current_path[2] == 'bad-bag-report'){
            activeTab = 2;
        } else if(current_path[2] == 'odd-bag-report'){
            activeTab = 3;
        } else if(current_path[2]=='balance-sheet'){
            activeTab=4;
        }
        //  else if(current_path[2] == 'summary-report'){
        //     activeTab = 3;
        // }
        this.state = {
            curation_stats: {
                "barcodes_count": 0,
                "assigned_barcodes_count": 0,
                "inprogress_barcodes_count": 0,
                "curated_barcodes_count": 0
            },
            show: false,
            selectedBarcode: {},
            selectedProfiler: "",
            selectedRows: [],
            toggleCleared: false,
            tabValue: activeTab,
        }
    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;

        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            if (newValue == 0) {
                this.props.history.push('/reports/community-report')
            } else if (newValue == 1) {
                this.props.history.push('/reports/city-report')
            } else if (newValue == 2) {
                this.props.history.push('/reports/bad-bag-report')
            } else if (newValue == 3) {
                this.props.history.push('/reports/odd-bag-report')
            } else if(newValue==4){
                this.props.history.push('/reports/balance-sheet')
            }
            // else if(newValue == 3){
            //     this.props.history.push('/reports/summary-report')
            // }
        };
        return (
            <div>
                <Typography variant="h4" className='page-title'>{t("Reports")}</Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Community Report" />
                        <Tab label="City Report" />
                        <Tab label="Bad Bag Report" />
                        <Tab label="Odd Bag Report" />
                        {
                          (["vijay@bintix.com", "kedarnath@bintix.com", "satheesh@bintix.com"].includes(this.props.user.email)) &&
                          <Tab label="Balance Sheet"/>
    }
                        {/* <Tab label="Summary Report"/> */}
                    </Tabs>
                </Box>
            </div>
        )
    }
}

export default withRouter(withTranslation()(ReportsHeader))
